import { InsuranceBox, RenderHtml } from '@flos/react-components';
import { useGlobalState } from '../../common/context/AppContext';
import { IAppConfig } from '../../common/interface/IAppConfig';
import { baseStyles } from '../../theme/base.styles';
import { useStyles } from './ReceiptScreen.styles';

type ReceiptFormProps = {
    config: IAppConfig;
};

export const ReceiptForm = ({ config }: ReceiptFormProps) => {
    const footerText = config.contentBlocks['onsa.travel.receipt.footer'].read();
    const baseClasses = baseStyles();
    const classes = useStyles();
    const { selectedPackage, selectedPaymentOption } = useGlobalState();
    const price = selectedPaymentOption ? selectedPaymentOption : { amount: 0, type: '', unit: 'kr./md.' };
    const packageName = selectedPackage.packageName;

    return (
        <>
            <InsuranceBox
                title={`${packageName} rejseforsikring`}
                iconshape="parasol"
                iconsize="42"
                textline1={'Dækker hele husstanden'}
                price={price.amount.toString()}
                priceformula={price.unit}
            />
            <div className={classes.footer}>
                <RenderHtml html={footerText.data} className={baseClasses.htmlWrapper} />
            </div>
        </>
    );
};
